import { createContext } from 'react'

interface SocketContextValue {
  socket: WebSocket | undefined
}

export const SocketContext = createContext<SocketContextValue>({
  socket: undefined,
})
